import { gql } from '@apollo/client';
import { MediaQueries } from '@minecraft.shared-queries';

const roleLocationDatesFragment = gql`
  fragment LocationDates on RoleDateWithLocation {
    __typename
    id
    startDate
    endDate
    cityName
    roleDateType {
      __typename
      id
      code
    }
  }
`;

const roleDetailsFragment = gql`
  fragment CastingRoleDetails on Role {
    __typename
    ageInYears
    ageMaxMonth
    ageMinMonth
    description
    displayedRoleUnion
    id
    isOpenCall
    name
    projectId
    projectName
    rateNote
    rateSummary
    requestMediaInstruction
    requestMediaTypes
    roleEthnicityNationality
    roleParentId
    scale
    sexualSituationDescription
    spot
    submissionDueDate
    submissionInstruction
    wardrobe
    workRequirement
    paidType {
      id
      name
      code
      __typename
    }
    roleStatus {
      id
      code
      name
      code
      __typename
    }
    roleType {
      id
      name
      __typename
    }
    roleUnion {
      id
      name
      __typename
    }
    skills {
      id
      name
      __typename
    }
    ethnicAppearance {
      id
      name
      __typename
    }
    genderAppearance {
      id
      name
      __typename
    }
    sexualSituations {
      id
      code
      name
      __typename
    }
    photos {
      __typename
      id
      roleMediaId
      mediaObject {
        __typename
        ...MediaAsset
      }
    }
    sides(checkSidesVisibility: $checkSidesVisibility) {
      __typename
      id
      roleMediaId
      mediaObject {
        __typename
        ...SidesMedia
      }
    }
    compensations {
      __typename
      compensation {
        __typename
        id
        code
        name
      }
      otherCompensation
    }
    locationDates {
      __typename
      ...LocationDates
    }
    timeZone {
      id
      standardName
      abbreviation
      __typename
    }
    __typename
  }
  ${roleLocationDatesFragment}
  ${MediaQueries.mediaAssetFragment}
  ${MediaQueries.sidesMediaFragment}
`;

const projectDetailsFragment = gql`
  fragment BlocsProjectDetails on Project {
    id
    createdByPC
    name
    internalName
    hidden
    tileSchemeId
    submissionsDueBy
    castingDirector
    castingAssociate
    castingAssistant
    contactPhone
    contactInfoPermissions
    contactEmail
    usage
    additionalProvisions
    synopsis
    notes
    network
    studio
    executiveProducer
    producer
    writer
    director
    productionCompany
    adAgency
    photographer
    projectConflicts {
      id
      name
    }
    organizations {
      id
      name
    }
    accounts {
      id
      firstName
      lastName
      email
      isIPC
      isCCD
    }
    media {
      ...MediaAsset
    }
    projectStatus {
      id
      name
      code
    }
    projectType {
      id
      name
    }
    projectUnion {
      contractId
      union {
        id
        code
        name
        childObjects {
          id
          name
          code
        }
      }
    }
    auditionType {
      id
      code
      name
      __typename
    }
    __typename
  }
  ${MediaQueries.mediaAssetFragment}
`;

export const GET_PROJECTS_FILTER_DATA = gql`
  query GET_PROJECTS_FILTER_DATA($artistId: Float!) {
    getNotificationEntitySubscriptionByArtist(artistId: $artistId) {
      roleTarget {
        id
        name
        code
        enabled
      }
    }
    roleTargets {
      id
      name
    }
    dmas {
      id
      name
      code
      region {
        id
        name
        code
        country {
          id
          code
          name
          continent {
            id
          }
        }
      }
    }
    projectUnions {
      id
      name
      code
      projectEnabled
      parentObject {
        id
      }
    }
    genderAppearances {
      id
      code
      name
    }
    projectTypes {
      id
      name
      code
      selectable
      parentObject {
        id
        name
        code
      }
    }
    ethnicAppearances {
      id
      name
      sortOrder
    }
    paidTypes {
      id
      code
      name
    }
  }
`;

export const PROJECT_DETAIL = gql`
  query PROJECT_DETAIL($ids: ID!) {
    projects(ids: [$ids]) {
      ...BlocsProjectDetails
    }
  }
  ${projectDetailsFragment}
`;

export const ROLE_DETAILS = gql`
  query ROLE_DETAILS($ids: ID!, $checkSidesVisibility: Boolean, $profileId: Int!) {
    roles(ids: [$ids]) {
      ...CastingRoleDetails
      publicationSettings {
        publicationSetting {
          id
          code
          __typename
        }
        dmas {
          id
          code
          name
          sortOrder
          __typename
        }
        __typename
      }
      rolePublishedAt
      locationDates {
        id
        startDate
        roleDateType {
          id
          code
          __typename
        }
        __typename
      }
      submissions(profileId: $profileId) {
        __typename
        id
        submissionStatus {
          __typename
          code
          name
          id
        }
        created
      }
    }
  }
  ${roleDetailsFragment}
`;

export const GET_SUBMISSION_BY_ROLE_PROFILE = gql`
  query GET_SUBMISSION_BY_ROLE_PROFILE($roleId: Int!, $profileId: Int!) {
    getSubmissionByRoleProfile(input: { roleId: $roleId, profileId: $profileId }) {
      id
      created
      submissionStatus {
        id
        name
        code
      }
    }
  }
`;

export const ADD_PROFILE_SUBMISSION = gql`
  mutation addProfileSubmission($roleId: Int!, $profileId: Int!, $submissionStatusCode: String!) {
    addProfileSubmission(
      input: { roleId: $roleId, profileIds: [$profileId], submissionStatusCode: $submissionStatusCode }
    )
  }
`;

export const DELETE_SUBMISSION = gql`
  mutation deleteSubmission($submissionId: BigInt!) {
    deleteSubmission(id: $submissionId)
  }
`;
